export default "__VITE_ASSET__dYrZbh3D__"